import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { selectVoucher } from '../../../../cartAndOrders/store/slice'
import useGetVAT from '../../../../common/category/useVAT'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { selectUserType } from '../../../../layout/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { USER_TYPE } from '../../../../utils/authorization'
import classes from '../../../index.module.scss'
import { Price } from './Price'
import { PriceDiscount } from './PriceDiscount'
import { BuyPackage } from './buyPackage/BuyPackage'
import {
  LIST_SUBCRIPTION_TERMS,
  LIST_SUBCRIPTION_TYPES,
  SUBSCRIPTION_TERMS_KEYS,
} from './constants'

export const SubscriptionForm = ({
  subscriptionType,
  setSubscriptionType,
  subscriptionTerm,
  setSubscriptionTerm,
  oldPrice,
  discountedPrice,
  isBuyPackage,
  setIsBuyPackage,
  discountSub,
  discountPackage,
}) => {
  const navigate = useNavigate()

  const userType = useSelector(selectUserType)
  const dataVoucher = useSelector(selectVoucher)

  const isStandardUser = userType?.userTypeId === USER_TYPE.STANDARD

  const { vatPercentage } = useGetVAT()

  const premiumTypeItem = LIST_SUBCRIPTION_TYPES[1]
  //price only subscription
  const priceDiscountOnlySub =
    discountedPrice * (discountSub?.discountPercentage || 0)
  const priceVoucherOnlySub =
    discountedPrice * (dataVoucher?.discountPercentage || 0)
  const totalPriceOnlySub = priceDiscountOnlySub + priceVoucherOnlySub

  const openPackageList = () => {
    navigate(
      COMPONENTS.userManagement.components.subscriptionPayment.components
        .packageList.route,
    )
  }

  const priceNotIncludedVAT = discountedPrice - totalPriceOnlySub
  const vatPrice = vatPercentage * priceNotIncludedVAT
  const grandTotalPrice = priceNotIncludedVAT + vatPrice

  const propsSub = {
    price: discountedPrice,
    discountPackage,
    discountSub,
    discountOderOnlySub: priceDiscountOnlySub,
    voucherOrderOnlySub: priceVoucherOnlySub,
    vatSub: vatPrice,
    grandTotalPriceSub: grandTotalPrice,
  }

  return (
    <div className={[classes.content, 'flexColumn'].join(' ')}>
      <div className={classes.upgradeAccRowContainer}>
        <Element className={[classes.title, 'fw600'].join(' ')}>
          <Translate value="userManagement.upgradeAccount.SUBSCRIPTION_TYPE" />
        </Element>
        <div className={classes.radioList}>
          {isStandardUser ? (
            <Radio
              key={premiumTypeItem.title}
              title={premiumTypeItem.title}
              isI18n
              value={premiumTypeItem.value}
              appendStyle={{ marginRight: 20 }}
              activeValue={premiumTypeItem.value}
            />
          ) : (
            LIST_SUBCRIPTION_TYPES.map((item) => (
              <Radio
                key={item.title}
                title={item.title}
                isI18n
                value={item.value}
                appendStyle={{ marginRight: 20 }}
                activeValue={subscriptionType}
                isCheckOnClickText
                onChange={setSubscriptionType}
              />
            ))
          )}
        </div>
      </div>
      <div className={classes.upgradeAccRowContainer}>
        <Element className={[classes.title, 'fw600'].join(' ')}>
          <Translate value="userManagement.upgradeAccount.SUBSCRIPTION_TERMS" />
        </Element>
        <div className={classes.radioList}>
          {LIST_SUBCRIPTION_TERMS.map((item) => {
            const isOneYear = item.value === SUBSCRIPTION_TERMS_KEYS.ONE_YEAR
            const itemTitle = isOneYear
              ? `${item.title}${I18n.t('userManagement.upgradeAccount.YEAR')}`
              : `${item.title}${I18n.t('userManagement.upgradeAccount.MONTHS')}`
            return (
              <Radio
                key={item.title}
                title={itemTitle}
                isI18n
                value={item.value}
                appendStyle={{ marginRight: 20 }}
                activeValue={subscriptionTerm}
                isCheckOnClickText
                onChange={setSubscriptionTerm}
              />
            )
          })}
        </div>
      </div>
      <Price
        oldPrice={oldPrice}
        price={discountedPrice}
        title="userManagement.upgradeAccount.PRICE"
      />

      {!isBuyPackage && (
        <>
          <Price
            title="userManagement.packageSubManagement.TRADE_DISCOUNT"
            price={0}
            classNamePrice={classes.w150}
          />
          <PriceDiscount
            price={totalPriceOnlySub}
            title="userManagement.buyPackage.TRADE_DISCOUNT"
            discount={discountSub}
          />
        </>
      )}

      {!isBuyPackage && <Price price={vatPrice} title="VAT" />}

      <Element className={classes.dashedLine} style={{ margin: '16px 0px' }} />

      {!isBuyPackage && (
        <Price
          price={grandTotalPrice}
          title="userManagement.buyPackage.GRAND_TOTAL"
          appendStyle={{ marginTop: -5, marginBottom: 10 }}
        />
      )}

      <div className="flexRow justifyContentBetween">
        <Checkbox
          checked={isBuyPackage}
          onChange={setIsBuyPackage}
          title="userManagement.upgradeAccount.BUY_PACKAGE_QUESTION"
          isCheckOnClickText
          isI18n
        />
        <Element
          elementName="span"
          style={{ color: '#2C73E8' }}
          onClick={openPackageList}
          className="cursorPointer"
        >
          <Translate value="userManagement.buyPackage.PACKAGE_LIST" />
        </Element>
      </div>
      {isBuyPackage ? (
        <BuyPackage subscriptionType={subscriptionType} propsSub={propsSub} />
      ) : (
        <></>
      )}
    </div>
  )
}
